export const primaryColor = "#3756C9";
export const primaryGrey4 = "#c4c4c4";
export const primaryGrey2 = "#f8f8f8";
export const primaryGrey3 = "#ebebeb";
export const textColor = "#545252";
export const deleteRed2= "#f9320d";
export const primaryPurple= "#2c358d";
export const primaryGreen= "#00a44b";